export default "__VITE_ASSET__D_UmYYH9__"